import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmartScreenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"smart_screen"}/>
}
